<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <!-- <v-card class="buy-vr-modal">
      <v-card-title class="subheading justify-center text-xs-justify">
        <span v-if="isUserDataEmpty">Your mobile and address details need confirmation</span>
        <span v-if="!isUserDataEmpty">Your mobile and address details</span>
        <p v-if="isUserDataEmpty">
          If this information is actual, please press on the button - "Correct".
          If you want to change this information, please edit here and click on the button - "Correct" button.
        </p>
        <p v-if="!isUserDataEmpty">
          Please add the following information considered as a delivery address.
          Once added, please press on the button - "Correct".
        </p>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-card-text>
          <v-container grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  box
                  label="Country"
                  placeholder="Country"
                  name="country"
                  data-vv-name="country"
                  v-validate="'required'"
                  :hide-details="userInfo.country.valid"
                  v-model="userInfo.country.value"
                  :error-messages="errors.collect('country')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  box
                  label="City"
                  placeholder="City"
                  name="city"
                  data-vv-name="city"
                  v-validate="'required'"
                  :hide-details="userInfo.city.valid"
                  v-model="userInfo.city.value"
                  :error-messages="errors.collect('city')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  box
                  label="Street"
                  placeholder="Street"
                  name="street"
                  data-vv-name="street"
                  v-validate="'required'"
                  :hide-details="userInfo.street.valid"
                  v-model="userInfo.street.value"
                  :error-messages="errors.collect('street')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  box
                  label="Building №"
                  placeholder="Building №"
                  name="building"
                  data-vv-name="building"
                  v-validate="'required'"
                  :hide-details="userInfo.building.valid"
                  v-model="userInfo.building.value"
                  :error-messages="errors.collect('building')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  box
                  label="Flat №"
                  placeholder="Flat №"
                  name="flat"
                  data-vv-name="flat"
                  v-validate="'required'"
                  :hide-details="userInfo.flat.valid"
                  v-model="userInfo.flat.value"
                  :error-messages="errors.collect('flat')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  box
                  label="phone"
                  placeholder="Phone"
                  name="phone"
                  data-vv-name="phone"
                  v-validate="'required'"
                  :hide-details="userInfo.phone.valid"
                  v-model="userInfo.phone.value"
                  :error-messages="errors.collect('phone')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  box
                  label="Zip code"
                  placeholder="Zip code"
                  name="zip_code"
                  data-vv-name="zip_code"
                  v-validate="'required'"
                  :hide-details="userInfo.zip_code.valid"
                  v-model="userInfo.zip_code.value"
                  :error-messages="errors.collect('zip_code')"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn dark color="purple" @click="submit">correct</v-btn>
        </v-card-actions>
      </v-form>
    </v-card> -->
    <showModal
      v-model="error.show"
      :message="'payment was done successfully'"
      :buttonText="'go to profile'"
      @on-apply="goHome"
    ></showModal>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import axios from "axios";
import showModal from "@/components/ShowModal";

Vue.use(VeeValidate);

export default {
  name: "buyVr",

  components: {
    showModal
  },

  data: () => ({
    dialog: true,
    valid: true,
    isUserDataEmpty: true,
    userInfo: {
      phone: { value: "", valid: true },
      country: { value: "", valid: true },
      city: { value: "", valid: true },
      street: { value: "", valid: true },
      building: { value: "", valid: true },
      flat: { value: "", valid: true },
      zip_code: { value: "", valid: true }
    },
    error: {
      show: true,
      msg: "",
      btnText: ""
    },
    dictionary: {
      custom: {
        phone: {
          required: () => "Mobile input can not be empty"
        },
        country: {
          required: () => "Country input can not be empty"
        },
        city: {
          required: () => "City input can not be empty"
        },
        street: {
          required: () => "Street input can not be empty"
        },
        building: {
          required: () => "Building input can not be empty"
        },
        flat: {
          required: () => "Flat input can not be empty"
        },
        zip_code: {
          required: () => "Zip Code input can not be empty"
        }
      }
    }
  }),

  created() {
    axios
      .get(this.$hostname + "/client/user_data/", {
        headers: {
          Authorization: localStorage.getItem("token")
        }
      })
      .then(response => {
        console.log(response.data);
        for (let param in this.userInfo) {
          if (response.data[param] !== "null") {
            this.userInfo[param].value = response.data[param];
          }
        }
      });
  },

  mounted() {
    this.$validator.localize("uk", this.dictionary);
    this.isUserDataEmpty = this.areObjectParamsEmpty(this.userInfo);
  },

  methods: {
    submit() {
      for (let param in this.userInfo) {
        this.userInfo[param].valid = true;
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          let formData = new FormData();
          formData.append("device_id", this.$route.params.device_id);
          formData.append("country", this.userInfo.country.value);
          formData.append("city", this.userInfo.city.value);
          formData.append("street", this.userInfo.street.value);
          formData.append("building", this.userInfo.building.value);
          formData.append("flat", this.userInfo.flat.value);
          formData.append("zipCode", this.userInfo.zip_code.value);
          formData.append("phone", this.userInfo.phone.value);
          axios
            .post(this.$hostname + "/client/updateUserDetails",formData, {
              headers: {
                Authorization: localStorage.getItem("token")
              }
            })
            .then(response => {
              if (response.status == 200) {
                this.error.msg =
                  "Your information was successfully confirmed and received. Our representative will contact you shortly to confirm this order.";
                this.error.btnText = "go to profile";
                this.error.show = true;
              } else {
                 this.error.msg =
                  "Smth going wrong";
                this.error.btnText = "try later";
                this.error.show = true;
              }
            })
            .catch(error => {
              this.error.msg = `${
                this.$store.getters.errorsList[error.response.data.message]
              }`;
              this.error.btnText = "try later";
              this.error.show = true;
            });
        }
        this.$validator.errors.items.forEach(input => {
          this.userInfo[input.field].valid = false;
        });
      });
    },

    goHome() {
      this.$router.push("/profile");
    },

    areObjectParamsEmpty(obj) {
      let result = [];
      for (let param in obj) {
        obj[param] ? result.push(true) : result.push(false);
      }
      return result.some(prop => {
        return prop.value;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-dialog {
  .v-card {
    .v-card__text,
    .v-card__title,
    .v-card__actions {
      padding-left: 30px;
      padding-right: 30px;
      p {
        font-size: 15px;
        margin-bottom: 0;
      }
    }
  }
}
</style>
